/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect } from 'react';
import { Container } from '@mui/material';
import { useParams } from 'react-router-dom';

const Home: React.FC = () => {
  const { state, city }: any = useParams();

  useEffect(() => {
    if (state && city) {
      localStorage.setItem('@mais/delivery/access_shop', 'access_shop');
    }
  }, [state, city]);

  return <Container />;
};

export default Home;
